module.exports = __webpack_public_path__ + "static/media/bg6.6fc6523f.jpg";